import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { select, Store } from '@ngrx/store';
import { Tiles } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { TileSet, TileSetType } from '../models/tile-set.model';
import { loadTileSet } from '../state/tile-set-type-select.actions';
import { selectTileSet } from '../state/tile-set-type-select.selectors';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-tile-set-type-select',
    styleUrls: ['./tile-set-type-select.component.scss'],
    templateUrl: './tile-set-type-select.component.html',
    standalone: false
})
export class TileSetTypeSelectComponent implements OnInit {
   @Input('tileId') tileId: Tiles;

   @Output() tileSetTypeChange = new EventEmitter<TileSetType>();

   value: TileSetType | null = null;

   tileSet$: Observable<TileSet | null>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.store.dispatch(loadTileSet({ tileId: this.tileId }));
      this.tileSet$ = this.store.pipe(select(selectTileSet(this.tileId)));
   }

   onTileSetTypeChange(value: MatSelectChange) {
      this.tileSetTypeChange.emit(value.value);
   }
}
